Ext.define('SA.XhrRequest', {
    constructor(cfg) {
        this.cfg = cfg;
    },

    closed() {
        return this.xhr.readyState === 4;
    },

    onChange() {
        this.cfg.onChange({
            closed: this.closed(),
            progress: this.progress,
            result: this.result
        });
    },

    onEnd() {
        if (this.didTimeout) {
            return;
        }

        var {json, jsonValid, jsonError} = SA.Json.parse(this.xhr.responseText),
            success = this.xhr.status === 200,
            error = success ? null : (jsonValid ? SA.AjaxError.get(json) : SA.AjaxError.getJsonParseError({cause: jsonError}));

        this.result = {success, error};
        this.onChange();
    },

    onProgress({loaded, total}) {
        this.progress = Math.round(loaded / total * 100);
        this.onChange();
    },

    send() {
        this.xhr = new XMLHttpRequest();
        this.xhr.upload.onprogress = this.onProgress.bind(this);
        this.xhr.addEventListener('loadend', this.onEnd.bind(this));
        this.xhr.open(this.cfg.httpMethod, this.cfg.url);
        this.xhr.setRequestHeader('Content-Type', 'application/json');
        this.xhr.send(JSON.stringify(this.cfg.data));

        return this;
    },

    unresolving() {
        return this;
    }
});
